module.exports = __webpack_public_path__ + "static/img/closeaE.10b5067.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/closeaE.png
// module id = ugE+
// module chunks = 1